import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'Greatr Admin';
  
  public LoginDetail: any = [];
  public loginTrue: boolean = false;
  public currentUrl:any ='';
  public loading:boolean = false;  

  constructor(private translate: TranslateService,public router: Router, public service: GlobalService) { 
    localStorage.setItem('gra_language','en');
    this.translate.use('en');
  }

  ngOnInit() {   
  }

  changeRoute() { 
    this.currentUrl =this.router.url;   
    if (localStorage.getItem("gra_login")) {
      this.LoginDetail = JSON.parse(localStorage.getItem("gra_login") || "{}");
      this.service.setSubject(this.LoginDetail);
    } 
    if(this.currentUrl == '/forgot-password' || this.currentUrl == '/signin' || this.currentUrl == '/'  || this.currentUrl == '/signup' || this.currentUrl == '/reset-password'){
      $('#beforeLoginbg').addClass('login-body')
    } else {
      $('#beforeLoginbg').removeClass('login-body')
    }
  }

}
